import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Spinner,
} from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { GetUserById, UpdateUser } from "../../services/users.service";
import {
  GetCounties,
  mapCountyOptions,
  resolveSelectedCounties,
} from "../../services/county.service";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { constants } from "../../utils/constants";
import { UploadIcon } from "../../components/SvgIcons";
import { UploadImageToS3 } from "../../utils/helpers";
import Select, { components } from "react-select";

const CountiesSelectInput = (props) => (
  <components.Input
    {...props}
    autoComplete="off"
    autoCorrect="off"
    spellCheck="false"
    aria-autocomplete="none"
  />
);

function EditOfficer(props) {
  let history = useHistory();
  const [data, setData] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [file, setFileData] = useState(false);
  const [defaultImage, setDefaultImage] = useState(false);
  const [countyOptions, setCountyOptions] = useState([]);

  const {
    register,
    watch,
    reset,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });


  useEffect(() => {
    const fetchData = async () => {
      const id = props.match.params.id;
      try {
        const countiesResult = await GetCounties(true);
        const list = Array.isArray(countiesResult?.data?.data)
          ? countiesResult.data.data
          : Array.isArray(countiesResult?.data)
            ? countiesResult.data
            : [];
        const options = mapCountyOptions(list);
        setCountyOptions(options);

        const result = await GetUserById(id);
        if (result.success && result.data) {
          setData(result.data);
          setDefaultImage(result.data.profile_image || constants.USERIMAGENOTFOUND);
          setValue("phone_number", result.data.phone_number);
          setValue("fax", result.data.fax || "");
          setValue("state", result.data.state);
          setValue("full_name", result.data.full_name);
          setValue("email", result.data.email);
          setValue("street", result.data.street || "");
          setValue("street_2", result.data.street_2 || "");
          setValue("city", result.data.city || "");
          setValue("zip_code", result.data.zip_code || "");
          setValue(
            "counties",
            resolveSelectedCounties(result.data, options)
          );
        } else {
          toast.error(result.message);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          EmptyLocalStorage();
          history.push("/");
        } else {
          toast.error(error.response ? error.response.data.message : "An error occurred");
        }
      }
    };

    fetchData();
  }, [props.match.params.id, setValue, history]);

  const onSubmit = async (formData) => {
    setDisableButton(true);
    try {
      let url = "";
      if (formData.media.length > 0) {
        const file = formData.media[0];
        if (file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jpeg") {
          const uploadImage = await UploadImageToS3(file);
          if (uploadImage.success) {
            url = uploadImage.data;
          } else {
            toast.error(uploadImage.message);
            setDisableButton(false);
            return;
          }
        } else {
          toast.error("Invalid file type.");
          setDisableButton(false);
          return;
        }
      } else {
        url = defaultImage;
      }

      const id = props.match.params.id;
      const userData = {
        state: formData.state,
        phone_number: formData.phone_number,
        fax: formData.fax?.trim() || null,
        profile_image: url,
        new_county: (formData.counties || []).map((item) => item.value),
        full_name: formData.full_name,
        email: formData.email,
        street: formData.street?.trim() || null,
        street_2: formData.street_2?.trim() || null,
        city: formData.city?.trim() || null,
        zip_code: formData.zip_code?.trim() || null,
      };

      if (formData.password && formData.password_confirmation) {
        userData.password = formData.password;
        userData.password_confirmation = formData.password_confirmation;
      }

      const result = await UpdateUser(id, userData);
      if (result.success) {
        toast.success(result.message);
        history.push("/manage-officer");
      } else {
        toast.error(result.message);
        setDisableButton(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        EmptyLocalStorage();
        history.push("/");
      } else {
        toast.error(error.response ? error.response.data.message : "An error occurred");
      }
      setDisableButton(false);
    }
  };



  const handleChange = (event) => {
    setFileData(URL.createObjectURL(event.target.files[0]));
  };



  return (
    <div className="AddNewUser">
      {/*<BreadcrumbsComponent />*/}
      <h3 className="page-heading">
        <span className="custom-color-maroon">Edit Officer -</span>{" "}
        {data.full_name}
      </h3>
      <hr />
      <Row>
        <Col xs={12} sm={12} md={8} lg={6} xl={6}>
          <Form
            className="formAddUser"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="mb-3 justify-content-center align-items-center">
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group
                  controlId="formFile"
                  onChange={(e) => handleChange(e)}
                  className="custom-file-upload mb-0"
                >
                  <Form.Label className="toggleFileUpload mb-0">
                    <UploadIcon />
                    Upload Image
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/gif"
                    {...register("media")}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <ul className="list-inline list-variations mb-0">
                  <li className="list-inline-item d-flex justify-content-between mb-0">
                    <img
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = constants.IMAGENOTFOUND;
                      }}
                      src={file ? file : defaultImage}
                      width="50%"
                      height="50%"
                    />
                  </li>
                </ul>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="full_name">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Full Name"
                    id={"formSignUpName"}
                    {...register("full_name", {
                      required: {
                        value: "required",
                        message: "Full Name is required",
                      },
                      pattern: {
                        value: /^[A-Za-z ]+$/,
                        message: "Invalid full name",
                      },
                      minLength: {
                        value: 3,
                        message: "Minimum length is 3",
                      },
                      maxLength: {
                        value: 25,
                        message: "Maximum length is 25",
                      },
                    })}
                    type="text"
                  />
                  {errors.full_name && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.full_name.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    placeholder="Enter Email Address"
                    autocomplete="off"
                    autofill="off"
                    {...register("email", {
                      required: {
                        value: "required",
                        message: "Email is required",
                      },
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: "Invalid email",
                      },
                      maxLength: {
                        value: 255,
                        message: "Maximum length is 255",
                      },
                    })}
                    type="text"
                  />
                  {errors.email && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.email.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="phone_number">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter Phone Number"
                    {...register("phone_number", {
                      required: {
                        value: "required",
                        message: "Phone is required",
                      },
                      pattern: {
                        value: /^\(\d{1,4}\)\s?\d{3}-?\d{3,7}$/,
                        message: "Please enter a valid phone number in the format (xxx) xxx-xxxx or (xxx) xxxxxxx",
                      },
                      minLength: {
                        value: 8,
                        message: "Minimum length is 8",
                      },
                      maxLength: {
                        value: 16,
                        message: "Maximum length is 16",
                      },
                    })}
                  />
                  {errors.phone_number && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.phone_number.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="fax">
                  <Form.Label>Fax</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Fax"
                    autoComplete="off"
                    {...register("fax", {
                      maxLength: {
                        value: 30,
                        message: "Maximum length is 30",
                      },
                    })}
                  />
                  {errors.fax && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.fax.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    placeholder="Current Location"
                    defaultValue={data.state}
                    autoComplete="off"
                    {...register("state", {
                      required: {
                        value: "required",
                        message: "State is required",
                      },
                      pattern: {
                        value: /^[A-Za-z ]+$/,
                        message: "invalid state name entered",
                      },
                      minLength: {
                        value: 3,
                        message: "Minimum length is 3",
                      },
                      maxLength: {
                        value: 25,
                        message: "Maximum length is 25",
                      },
                    })}
                    type="text"
                  />
                  {errors.state && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.state.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="counties">
                  <Form.Label>Counties</Form.Label>
                  <Controller
                    control={control}
                    name="counties"
                    rules={{
                      required: "Counties is required",
                      validate: (value) =>
                        (value && value.length > 0) ||
                        "Please select at least one county",
                    }}
                    render={({ field: { onChange, value, ref } }) => (
                      <Select
                        name="officer_counties"
                        inputId="edit-officer-counties"
                        instanceId="edit-officer-counties"
                        inputRef={ref}
                        value={value || []}
                        onChange={onChange}
                        options={countyOptions}
                        isSearchable={true}
                        isMulti={true}
                        placeholder="Select Counties"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        components={{ Input: CountiesSelectInput }}
                      />
                    )}
                  />
                  {errors.counties && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.counties.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="street">
                  <Form.Label>Street</Form.Label>
                  <Form.Control
                    placeholder="Enter Street"
                    autoComplete="off"
                    type="text"
                    {...register("street", {
                      maxLength: {
                        value: 255,
                        message: "Maximum length is 255",
                      },
                    })}
                  />
                  {errors.street && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.street.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="street_2">
                  <Form.Label>Street 2</Form.Label>
                  <Form.Control
                    placeholder="Enter Street 2"
                    autoComplete="off"
                    type="text"
                    {...register("street_2", {
                      maxLength: {
                        value: 255,
                        message: "Maximum length is 255",
                      },
                    })}
                  />
                  {errors.street_2 && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.street_2.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    placeholder="Enter City"
                    autoComplete="off"
                    type="text"
                    {...register("city", {
                      maxLength: {
                        value: 100,
                        message: "Maximum length is 100",
                      },
                    })}
                  />
                  {errors.city && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.city.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="zip_code">
                  <Form.Label>Zip Code</Form.Label>
                  <Form.Control
                    placeholder="Enter Zip Code"
                    autoComplete="off"
                    type="text"
                    {...register("zip_code", {
                      maxLength: {
                        value: 10,
                        message: "Maximum length is 10",
                      },
                    })}
                  />
                  {errors.zip_code && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.zip_code.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter Password"
                    autoComplete="new-password"
                    {...register("password", {
                      minLength: {
                        value: 8,
                        message: "Minimum length is 8",
                      },
                    })}
                  />
                  {errors.password && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.password.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="password_confirmation">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm Password"
                    autoComplete="new-password"
                    {...register("password_confirmation", {
                      validate: (value) =>
                        value === watch("password") || "Passwords do not match",
                    })}
                  />
                  {errors.password_confirmation && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.password_confirmation.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Button
                  type="submit"
                  className="btn btn-green-theme w-100 mt-3"
                  disabled={disableButton}
                >
                  {disableButton ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Updating...
                    </>
                  ) : (
                    "Edit Officer"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default EditOfficer;
